module.exports = __webpack_public_path__ + "static/media/office1.0e325be5.jpg";